import { ConversionBlock } from '@/entities/conversion/ui/ConversionBlock/ConversionBlock'
import {
  PaymentRequisitIcon,
  PaymentRequisiteToStatus,
  PaymentRequisiteStatusMap,
} from '@/entities/paymentRequisit'
import { Roles } from '@/entities/roles'
import { TopupModel, TopupModelMerchant } from '@/entities/topup'
import { StatusLabel } from '@/shared/components'
import { ItemBaseBlock } from '@/shared/components/ItemBaseBlock/ItemBaseBlock'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'
import { formatRequisite } from '@/shared/lib'
import { REQUISITE_TYPES } from '@/features/requisites'

type Props = {
  data: TopupModel | TopupModelMerchant
  userRole: Roles | null
}

export const RequisiteBlock = ({ data, userRole }: Props) => {
  const isTrader = userRole === Roles.Trader
  const isMerchant = userRole === Roles.Merchant

  const subtitleClasses = 'text-sm text-text-secondary'
  const columnClasses = 'flex flex-col gap-[10px] md:gap-4'

  if (isTrader) {
    const traderData = { ...data } as TopupModel
    const statusInfo = PaymentRequisiteStatusMap[traderData.paymentRequisitProfile.status]
    const requisite = formatRequisite(
      traderData.paymentRequisitProfile.value
    )

    return (
      <ItemBaseBlock title="Реквизит" type="requisite" id={traderData.requisitProfile.id}>
        <div className="flex md:flex-row flex-col justify-between items-start gap-6 md:gap-2 text-sm">
          {/* Реквизит */}
          <div className={columnClasses}>
            <span className={subtitleClasses}>Реквизит</span>
            <div className="flex items-center gap-3">
              <PaymentRequisitIcon
                accountType={traderData.paymentRequisitProfile.type}
                status={traderData.paymentRequisitProfile.status}
                bg
              />
              <div className="flex flex-col font-klein font-medium">
                <CopyBlock text={traderData.paymentRequisitProfile.value}>{requisite}</CopyBlock>

                <span className="text-text-secondary">
                  {traderData.requisitProfile.bankToName ?? 'Нет данных'}
                </span>
              </div>
            </div>
          </div>

          {/* Получатель */}
          <div className={columnClasses}>
            <span className={subtitleClasses}>Получатель</span>
            <span className="font-klein font-medium">
              {traderData.requisitProfile.recipientName ?? 'Нет данных'}
            </span>
          </div>

          {/* Статус */}
          <div className={columnClasses}>
            <span className={subtitleClasses}>Статус</span>
            <StatusLabel status={statusInfo.color}>{statusInfo.title}</StatusLabel>
          </div>

          {/* Конверсия */}
          <div className={columnClasses}>
            <span className={subtitleClasses}>Конверсия</span>
            <ConversionBlock
              current={traderData.paymentRequisitProfile.successTopupCounter}
              goal={traderData.paymentRequisitProfile.initiatedTopupsCounter}
            />
          </div>
        </div>
      </ItemBaseBlock>
    )
  }

  if (isMerchant) {
    const merchantData = { ...data } as TopupModelMerchant

    const requisite = formatRequisite(
      merchantData.paymentRequisitToValue
    )

    const paymentName = REQUISITE_TYPES[merchantData.paymentRequisitToType].label

    return (
      <ItemBaseBlock title="Реквизит" type="requisite" userRole={userRole}>
        <div className="flex md:flex-row flex-col items-start gap-6 md:gap-20 text-sm">
          {/* Реквизит */}
          <div className={`${columnClasses}`}>
            <span className={subtitleClasses}>Реквизит</span>
            <div className="flex items-center gap-3">
              <PaymentRequisitIcon
                accountType={merchantData.paymentRequisitToType}
                status={PaymentRequisiteToStatus.Unknown}
                bg
              />
              <div className="flex flex-col font-klein font-medium">
                <span>{requisite}</span>
                <span className="text-text-secondary">{paymentName}</span>
              </div>
            </div>
          </div>

          {/* Получатель */}
          <div className={columnClasses}>
            <span className={subtitleClasses}>Получатель</span>
            <span className="font-klein font-medium">{merchantData.fullName ?? 'Нет данных'}</span>
          </div>
        </div>
      </ItemBaseBlock>
    )
  }
}
